/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ISiloRepository,
  ISiloRepositoryInterface,
} from "../ISiloRepository";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint64",
            name: "maxLoanToValue",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "liquidationThreshold",
            type: "uint64",
          },
          {
            internalType: "contract IInterestRateModel",
            name: "interestRateModel",
            type: "address",
          },
        ],
        indexed: false,
        internalType: "struct ISiloRepository.AssetConfig",
        name: "assetConfig",
        type: "tuple",
      },
    ],
    name: "AssetConfigUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newBridgeAsset",
        type: "address",
      },
    ],
    name: "BridgeAssetAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "bridgeAssetRemoved",
        type: "address",
      },
    ],
    name: "BridgeAssetRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "pool",
        type: "address",
      },
    ],
    name: "BridgePool",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "newEntryFee",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "newProtocolShareFee",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "newProtocolLiquidationFee",
        type: "uint64",
      },
    ],
    name: "FeeUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IInterestRateModel",
        name: "newModel",
        type: "address",
      },
    ],
    name: "InterestRateModel",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "defaultLiquidationThreshold",
        type: "uint64",
      },
    ],
    name: "NewDefaultLiquidationThreshold",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "defaultMaximumLTV",
        type: "uint64",
      },
    ],
    name: "NewDefaultMaximumLTV",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "silo",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "siloVersion",
        type: "uint128",
      },
    ],
    name: "NewSilo",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract INotificationReceiver",
        name: "newIncentiveContract",
        type: "address",
      },
    ],
    name: "NotificationReceiverUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IPriceProvidersRepository",
        name: "newProvider",
        type: "address",
      },
    ],
    name: "PriceProvidersRepositoryUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "factory",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "siloLatestVersion",
        type: "uint128",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "siloDefaultVersion",
        type: "uint128",
      },
    ],
    name: "RegisterSiloVersion",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newRouter",
        type: "address",
      },
    ],
    name: "RouterUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "newDefaultVersion",
        type: "uint128",
      },
    ],
    name: "SiloDefaultVersion",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "newTokensFactory",
        type: "address",
      },
    ],
    name: "TokensFactoryUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "factory",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "siloVersion",
        type: "uint128",
      },
    ],
    name: "UnregisterSiloVersion",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "version",
        type: "uint128",
      },
    ],
    name: "VersionForAsset",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newBridgeAsset",
        type: "address",
      },
    ],
    name: "addBridgeAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_assetIsABridge",
        type: "bool",
      },
    ],
    name: "ensureCanCreateSiloFor",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "entryFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getBridgeAssets",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getInterestRateModel",
    outputs: [
      {
        internalType: "contract IInterestRateModel",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getLiquidationThreshold",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getMaximumLTV",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
    ],
    name: "getNotificationReceiver",
    outputs: [
      {
        internalType: "contract INotificationReceiver",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getRemovedBridgeAssets",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getSilo",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
    ],
    name: "getVersionForAsset",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
    ],
    name: "isSilo",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "_siloData",
        type: "bytes",
      },
    ],
    name: "newSilo",
    outputs: [
      {
        internalType: "address",
        name: "createdSilo",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepository",
    outputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "protocolLiquidationFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "protocolShareFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract ISiloFactory",
        name: "_factory",
        type: "address",
      },
      {
        internalType: "bool",
        name: "_isDefault",
        type: "bool",
      },
    ],
    name: "registerSiloVersion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bridgeAssetToRemove",
        type: "address",
      },
    ],
    name: "removeBridgeAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_siloVersion",
        type: "uint128",
      },
      {
        internalType: "bytes",
        name: "_siloData",
        type: "bytes",
      },
    ],
    name: "replaceSilo",
    outputs: [
      {
        internalType: "address",
        name: "createdSilo",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "router",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint64",
            name: "maxLoanToValue",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "liquidationThreshold",
            type: "uint64",
          },
          {
            internalType: "contract IInterestRateModel",
            name: "interestRateModel",
            type: "address",
          },
        ],
        internalType: "struct ISiloRepository.AssetConfig",
        name: "_assetConfig",
        type: "tuple",
      },
    ],
    name: "setAssetConfig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IInterestRateModel",
        name: "_defaultInterestRateModel",
        type: "address",
      },
    ],
    name: "setDefaultInterestRateModel",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "_defaultLiquidationThreshold",
        type: "uint64",
      },
    ],
    name: "setDefaultLiquidationThreshold",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint64",
        name: "_defaultMaxLTV",
        type: "uint64",
      },
    ],
    name: "setDefaultMaximumLTV",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "_defaultVersion",
        type: "uint128",
      },
    ],
    name: "setDefaultSiloVersion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint64",
            name: "entryFee",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "protocolShareFee",
            type: "uint64",
          },
          {
            internalType: "uint64",
            name: "protocolLiquidationFee",
            type: "uint64",
          },
        ],
        internalType: "struct ISiloRepository.Fees",
        name: "_fees",
        type: "tuple",
      },
    ],
    name: "setFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_silo",
        type: "address",
      },
      {
        internalType: "contract INotificationReceiver",
        name: "_notificationReceiver",
        type: "address",
      },
    ],
    name: "setNotificationReceiver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceProvidersRepository",
        name: "_repository",
        type: "address",
      },
    ],
    name: "setPriceProvidersRepository",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_router",
        type: "address",
      },
    ],
    name: "setRouter",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokensFactory",
        type: "address",
      },
    ],
    name: "setTokensFactory",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "_version",
        type: "uint128",
      },
    ],
    name: "setVersionForAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_siloVersion",
        type: "uint256",
      },
    ],
    name: "siloFactory",
    outputs: [
      {
        internalType: "contract ISiloFactory",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "siloRepositoryPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "tokensFactory",
    outputs: [
      {
        internalType: "contract ITokensFactory",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "_siloVersion",
        type: "uint128",
      },
    ],
    name: "unregisterSiloVersion",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ISiloRepository__factory {
  static readonly abi = _abi;
  static createInterface(): ISiloRepositoryInterface {
    return new utils.Interface(_abi) as ISiloRepositoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISiloRepository {
    return new Contract(address, _abi, signerOrProvider) as ISiloRepository;
  }
}
